import * as React from 'react'
import styled from 'styled-components'

import { CheckIcon } from '../icons'
import { Constants } from '~/utils/Constants'

const ModalMessageWrapper = styled.div<{ $center?: boolean }>`
  text-align: ${(props) => (props.$center ? 'center' : 'left')};

  img {
    width: 100px;
  }
`

type ISuccessMessage = {
  success?: boolean
  message?: React.ReactNode
  centermessage?: boolean
}

export function ModalMessage({
  success,
  message,
  centermessage,
}: ISuccessMessage) {
  return (
    <ModalMessageWrapper $center={centermessage}>
      {success && <CheckIcon width="80px" fill={Constants.THEME.success} />}
      <div>{message}</div>
    </ModalMessageWrapper>
  )
}
